import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { StoryblokImage, StoryblokRichContent } from '../../models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExponeaService } from '~shared/services/exponea.service';
import { getCountryDomainCode } from '~server/utils/country-detection.util';
import { Subject } from 'rxjs';
import { environment } from '~env/environment';
import { MediaObserver } from '@angular/flex-layout';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-custom-sign-up',
  templateUrl: './custom-sign-up.component.html',
  styleUrls: ['./custom-sign-up.component.scss'],
})
export class CustomSignUpComponent {
  @Input() title?: string;
  @Input() source?: string;
  @Input() subTitle?: string;
  @Input() imageLeft?: StoryblokImage;
  @Input() buttonText?: string;
  @Input() termsAndConditions?: StoryblokRichContent;
  @Input() confirmationMessage?: StoryblokRichContent;

  destroySubject = new Subject();
  newsLetterImage: string;
  newsLetterImageMobile: string;
  public form: FormGroup;
  isFormSubmitted = false;
  isLoading = false;
  isMobile = false;
  pageSlug = '';
  market: string;

  constructor(
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
    private exponeaService: ExponeaService
  ) {
    this.market = getCountryDomainCode();
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.newsLetterImage = `${environment.cdnBaseUrl()}/images/desktop-newsletter-character.png`;
    this.newsLetterImageMobile = `${environment.cdnBaseUrl()}/images/mobile-newsletter-character.png`;
  }

  ngOnInit(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject))
      .subscribe(() => {
        this.isMobile = this.mediaObserver.isActive('mm-mobile') || this.mediaObserver.isActive('mm-tablet');
      });
    this.pageSlug = this.getPageSlug();
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;

      this.exponeaService.sendVisitorsEventData(this.form.value.email, this.source, this.pageSlug)
        .toPromise()
        .then(() => {
          this.isFormSubmitted = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isFormSubmitted = false;
          this.isLoading = false;
        })
        .finally(() => {
          this.isLoading = false;
          this.cd.detectChanges();
        })
    }
  }

  getPageSlug(): string {
    return window.location.pathname.split('/').pop() || '';
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
